import { MatchingColorsObj } from '../Context/GarmentContext/garmentContextFunctions';
import { GarmentPricesLogRow } from '../types/databaseTables/garmentpriceslog';
import { NewTeeTypesRow } from '../types/databaseTables/newteetypes';
import { TeeMeasuresAveragesRow } from '../types/databaseTables/teemeasuresaverages';
import { VendorsRow } from '../types/databaseTables/vendors';
import { FilterStateLocalStorage } from '../types/reducers/filterReducer';

export function getNewTeeTypesRowsFromLocalStorage(): NewTeeTypesRow[] | [] {
    return JSON.parse(localStorage.getItem('newTeeTypes') || '[]') as NewTeeTypesRow[] | [];
}

export function getTeeMeasuresAveragesRowsFromLocalStorage(): TeeMeasuresAveragesRow[] | [] {
    return JSON.parse(localStorage.getItem('teeMeasuresAverages') || '[]') as TeeMeasuresAveragesRow[] | [];
}

export function getVendorsFromLocalStorage(): VendorsRow[] | [] {
    return JSON.parse(localStorage.getItem('vendors') || '[]') as VendorsRow[] | [];
}

export function getCostsLogFromLocalStorage(): GarmentPricesLogRow[] | [] {
    return JSON.parse(localStorage.getItem('costslogarray') || '[]') as GarmentPricesLogRow[] | [];
}

export function getMatchingColorsFromLocalStorage(): MatchingColorsObj {
    return JSON.parse(localStorage.getItem('matchingcolors') || '{}') as MatchingColorsObj;
}

export function getMaterialsFromLocalStorage(): string[] {
    return JSON.parse(localStorage.getItem('materials') || '[]') as string[];
}

export function getUniqueColorsFromLocalStorage(): string[] {
    return JSON.parse(localStorage.getItem('uniqueColors') || '[]') as string[];
}

export function getFilterSettingsFromLocalStorage(): FilterStateLocalStorage | null {
    return JSON.parse(localStorage.getItem('filterSettings') || 'null') as FilterStateLocalStorage | null;
}